export enum EditUserTab {
  PROFILE = 'profile',
  VEHICULE_CHECKS = 'vehicule-checks',
  SECURITY = 'security',
}
